import React, { useState } from 'react';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

export const FinalAsktheExpertScreenJSX = (props) => {
    const { onHomebuttonClick } = props;
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    const [isPopupVisible, setIsPopupVisible] = useState(true);
    const handleClosePopup = () => {
        setIsPopupVisible(false);
        window.location.reload()
    };
    return (
        <>


            {isPopupVisible && (
                <div className="thankyoupopup popupouter ">
                    <div className="popup">
                        <div className="row">
                            <div className="col-lg-12 col-sm-12">
                                <div className="thankyou">
                                    <div className="thakyoutext">
                                        <h2><Trans i18nKey="FINALASKTHEEXPERT.QUESTIONHEADING"></Trans></h2>
                                        <p className="thankyousubtext"><Trans i18nKey="FINALASKTHEEXPERT.SUBHEADING"></Trans></p>
                                        <p className="thankyousubtext2"><Trans i18nKey="FINALASKTHEEXPERT.TEXT1"></Trans></p>
                                    </div>
                                    <div className="thankyoubtn">
                                        <Link to="/home" onClick={onHomebuttonClick} className="thankyoubutton"><Trans i18nKey="FINALASKTHEEXPERT.BTN1"></Trans></Link>
                                        <a href="/askTheExpert#ask" onClick={handleClosePopup} className="thankyoubutton2">
                                        <Trans i18nKey="FINALASKTHEEXPERT.BTN2"></Trans>
                  </a>
                                    </div>
                                    <div className="thakyoutext">
                                        <p className="thankyousubtext"><Trans i18nKey="FINALASKTHEEXPERT.TEXT2"></Trans></p>
                                        <p className="thankyousubtext2"><Trans i18nKey="FINALASKTHEEXPERT.TEXT3"></Trans>
                            </p>

                                    </div>
                                    <div className="thankyou2btn">
                                        <Link to="/customerRegistration" className="thankyou2button"><Trans i18nKey="FINALASKTHEEXPERT.BTN3"></Trans></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* <Footer /> */}

        </>
    )
}